import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex items-start justify-between gap-4 border-b border-slate-200 px-5 py-4" }
const _hoisted_2 = { class: "text-lg font-bold capitalize text-slate-900" }
const _hoisted_3 = { class: "max-h-[75vh] overflow-y-auto bg-white" }
const _hoisted_4 = { class: "divide-y divide-slate-100" }
const _hoisted_5 = { class: "grid grid-cols-1 gap-3 px-5 py-3 md:grid-cols-[170px_1fr] md:items-center" }
const _hoisted_6 = { class: "grid grid-cols-1 gap-3 px-5 py-3 md:grid-cols-[170px_1fr] md:items-center" }
const _hoisted_7 = { class: "grid grid-cols-1 gap-3 px-5 py-3 md:grid-cols-[170px_1fr] md:items-center" }
const _hoisted_8 = { class: "grid grid-cols-1 gap-3 px-5 py-3 md:grid-cols-[170px_1fr] md:items-start" }
const _hoisted_9 = { class: "grid grid-cols-1 gap-3 px-5 py-3 md:grid-cols-[170px_1fr] md:items-center" }
const _hoisted_10 = { class: "flex items-center gap-3" }
const _hoisted_11 = { class: "flex h-14 w-14 shrink-0 items-center justify-center overflow-hidden rounded-lg border border-slate-200 bg-slate-100" }
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 1,
  class: "text-xs text-slate-400"
}
const _hoisted_14 = { class: "grid grid-cols-1 gap-3 px-5 py-3 md:grid-cols-[170px_1fr] md:items-start" }
const _hoisted_15 = {
  key: 0,
  class: "mt-1 text-xs text-slate-500"
}
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "flex items-center justify-end gap-2 border-t border-slate-200 bg-slate-50 px-5 py-3" }
const _hoisted_18 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "fixed inset-0 z-[998] bg-slate-900/50 backdrop-blur-sm" }, null, -1)),
    _createElementVNode("div", {
      class: "fixed inset-0 z-[999] flex items-center justify-center p-4",
      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
    }, [
      _createElementVNode("div", {
        ref: "modalContent",
        onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"])),
        class: "w-full max-w-[760px]"
      }, [
        _createElementVNode("form", {
          onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"])),
          class: "overflow-hidden rounded-lg border border-slate-200 bg-white shadow-2xl"
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", null, [
              _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.title), 1),
              _cache[11] || (_cache[11] = _createElementVNode("p", { class: "mt-1 text-sm text-slate-500" }, "Kelola profil mitra, kontak internal, logo, dan dokumen MoU.", -1))
            ]),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
              class: "rounded-lg p-1.5 text-slate-400 transition hover:bg-slate-100 hover:text-slate-700"
            }, [...(_cache[12] || (_cache[12] = [
              _createElementVNode("svg", {
                class: "h-5 w-5",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M6 18L18 6M6 6l12 12"
                })
              ], -1)
            ]))])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[13] || (_cache[13] = _createElementVNode("div", null, [
                  _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, [
                    _createTextVNode("Nama Mitra "),
                    _createElementVNode("span", { class: "text-red-500" }, "*")
                  ]),
                  _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Nama institusi atau organisasi mitra.")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.name) = $event)),
                  type: "text",
                  required: "",
                  class: "block w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-800 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20",
                  placeholder: "mis. PT Example"
                }, null, 512), [
                  [_vModelText, _ctx.form.name]
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[14] || (_cache[14] = _createElementVNode("div", null, [
                  _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, "Nama PIC"),
                  _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Kontak internal, tidak tampil di publik.")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.picName) = $event)),
                  type: "text",
                  class: "block w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-800 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20",
                  placeholder: "mis. Budi Santoso"
                }, null, 512), [
                  [_vModelText, _ctx.form.picName]
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[15] || (_cache[15] = _createElementVNode("div", null, [
                  _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, "Telepon PIC"),
                  _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Nomor yang dapat dihubungi admin.")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.picPhone) = $event)),
                  type: "tel",
                  class: "block w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-800 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20",
                  placeholder: "mis. 08123456789"
                }, null, 512), [
                  [_vModelText, _ctx.form.picPhone]
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "md:pt-2" }, [
                  _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, "Deskripsi"),
                  _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Ringkasan kerja sama dengan mitra.")
                ], -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.description) = $event)),
                  rows: "3",
                  class: "block w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-800 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20",
                  placeholder: "Deskripsi singkat tentang mitra..."
                }, null, 512), [
                  [_vModelText, _ctx.form.description]
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[17] || (_cache[17] = _createElementVNode("div", null, [
                  _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, "Logo"),
                  _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Gambar logo mitra.")
                ], -1)),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    (_ctx.logoPreview)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.logoPreview,
                          alt: "Preview logo",
                          class: "h-full w-full object-cover"
                        }, null, 8, _hoisted_12))
                      : (_openBlock(), _createElementBlock("span", _hoisted_13, "Kosong"))
                  ]),
                  _createElementVNode("input", {
                    type: "file",
                    accept: "image/*",
                    onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onLogoChange && _ctx.onLogoChange(...args))),
                    class: "block w-full text-sm text-slate-600 file:mr-3 file:rounded-lg file:border-0 file:bg-blue-50 file:px-3 file:py-2 file:text-sm file:font-semibold file:text-blue-700 hover:file:bg-blue-100"
                  }, null, 32)
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _cache[18] || (_cache[18] = _createElementVNode("div", null, [
                  _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, "MoU (PDF)"),
                  _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Dokumen kerja sama yang tersimpan.")
                ], -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("input", {
                    type: "file",
                    accept: "application/pdf",
                    onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onMouChange && _ctx.onMouChange(...args))),
                    class: "block w-full text-sm text-slate-600 file:mr-3 file:rounded-lg file:border-0 file:bg-blue-50 file:px-3 file:py-2 file:text-sm file:font-semibold file:text-blue-700 hover:file:bg-blue-100"
                  }, null, 32),
                  (_ctx.mouName)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, "File: " + _toDisplayString(_ctx.mouName), 1))
                    : (_ctx.form.mou)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          href: _ctx.form.mou,
                          target: "_blank",
                          rel: "noopener",
                          class: "mt-1 inline-block text-xs font-semibold text-blue-600 hover:underline"
                        }, "Lihat file saat ini", 8, _hoisted_16))
                      : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
              class: "rounded-lg border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-600 hover:bg-slate-100"
            }, " Batal "),
            _createElementVNode("button", {
              type: "submit",
              disabled: _ctx.isLoading,
              class: "rounded-lg bg-blue-800 px-5 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-60"
            }, _toDisplayString(_ctx.isLoading ? 'Menyimpan...' : 'Simpan'), 9, _hoisted_18)
          ])
        ], 32)
      ], 512)
    ])
  ], 64))
}